import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4435bc87")

_pushScopeId("data-v-4435bc87")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "CodeMirrorMathematica" }, [
  /*#__PURE__*/_createVNode("div", { class: "CodeMirror-code formula" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "fa fa-ban invalidCell"
}
const _hoisted_3 = {
  key: 1,
  class: "fa fa-check selectedCell"
}
const _hoisted_4 = {
  key: 2,
  class: "fa fa-lock selectedCell"
}
const _hoisted_5 = {
  key: 3,
  class: "fa fa-check selectableCell"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, {
      style: _ctx.tabViewDescriptor.style.cardinalityCard
    }, {
      content: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["style"]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          style: _ctx.tabViewDescriptor.style.card
        }, {
          content: _withId(() => [
            _createVNode(_component_DataTable, {
              value: _ctx.attributesList,
              responsiveLayout: "scroll",
              class: "cardinalityTable"
            }, {
              default: _withId(() => [
                _createVNode(_component_Column, null, {
                  body: _withId((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data), 1)
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpi.cardinality.measureList, (measure) => {
                  return (_openBlock(), _createBlock(_component_Column, { key: measure }, {
                    header: _withId(() => [
                      _createVNode("div", {
                        style: _ctx.tabViewDescriptor.style.cardinalityColumn
                      }, _toDisplayString(measure.measureName), 5)
                    ]),
                    body: _withId((slotProps) => [
                      (_ctx.measureHaveAttribute(slotProps.data, slotProps.column.key))
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "measureCell",
                            onClick: ($event: any) => (_ctx.toggleCell(slotProps.data, slotProps.column.key))
                          }, [
                            (!_ctx.isEnabled(slotProps.data, slotProps.column.key))
                              ? (_openBlock(), _createBlock("i", _hoisted_2))
                              : _createCommentVNode("", true),
                            (measure.attributes[slotProps.data])
                              ? (_openBlock(), _createBlock("i", _hoisted_3))
                              : _createCommentVNode("", true),
                            (measure.attributes[slotProps.data] && !_ctx.canDisable(slotProps.data, slotProps.column.key))
                              ? (_openBlock(), _createBlock("i", _hoisted_4))
                              : _createCommentVNode("", true),
                            (!measure.attributes[slotProps.data] && _ctx.isEnabled(slotProps.data, slotProps.column.key))
                              ? (_openBlock(), _createBlock("i", _hoisted_5))
                              : _createCommentVNode("", true)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 64))
})